import React from 'react';
import PropTypes from 'prop-types';

export default function LandUsageIcon({ color = '#ffffff', width = 20, height = 20 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={width} height={height} fill={color}>
      <path d="M490.7 277.3H443 388l-24-42.7h57.6L352 95.4l-31.2 62.4-25.3-44.9 32.6-65.2L352 0l23.9 47.7 93.5 187 21.3 42.7zM112 298.7H69 21.3L42.7 256 136.1 69 160 21.3 183.9 69l27 53.9 20.7-36.8L256 42.7l24.5 43.5L424 341.3 448 384H399 277.3V512H234.7V384H113 64l24-42.7 24-42.7zm73.6-130.8L160 116.7 90.4 256H136l49.6-88.1zM256 129.7L137 341.3H375L256 129.7z" />
    </svg>
  );
}

LandUsageIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
